import {
    Navigate,
    Outlet,
    RouteProps,
} from 'react-router-dom';

import { useAuth } from './AuthProvider';

type ProtectedRouteProps = RouteProps & {
    requiredRole?: any;
  }

export const ProtectedRoute = ({ requiredRole }: ProtectedRouteProps) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated()) {
        return <Navigate to="/login" />;
    }

    return <Outlet />;
};
